import { Box } from "@chakra-ui/react"
import { motion } from "framer-motion"
import React, { useEffect } from "react"
import { useAnimation } from "framer-motion"
import { blocksVisibilityState } from "./atoms"
import { useRecoilValue } from "recoil"

const MotionBox = motion(Box)

interface Props {
  htmlBody: string
  showOnBlockIds: string[]
  isAlwaysVisible?: boolean
}

const FloatingActionButton: React.FC<Props> = ({
  htmlBody = "<button>Get Started</button>",
  showOnBlockIds = [],
  isAlwaysVisible = false,
}) => {
  const controls = useAnimation()
  const hasABlockInView = useRecoilValue(blocksVisibilityState(showOnBlockIds))
  const isVisible = hasABlockInView || Boolean(isAlwaysVisible)

  useEffect(() => {
    controls.start({
      y: isVisible ? 0 : "100%",
      transition: { duration: 0.3, ease: "easeInOut" },
    })
  }, [controls, isVisible])

  return (
    <Box display={{ base: "block", md: "none" }}>
      <MotionBox
        position="fixed"
        bottom="0"
        width="full"
        initial={{ y: "100%" }}
        animate={controls}
        zIndex={10}
      >
        <Box
          dangerouslySetInnerHTML={{
            __html: htmlBody,
          }}
        />
      </MotionBox>
    </Box>
  )
}

export default FloatingActionButton
